module.exports = __webpack_public_path__ + "static/media/carouselImage.99ce05f9.svg";